// extracted by css-extract-rspack-plugin
export default {"drillDetail":"EHpdi","image":"mJCbm"};